'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _InstagramPic = require('./InstagramPic.js');

var _InstagramPic2 = _interopRequireDefault(_InstagramPic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramPicker = function (_Component) {
  (0, _inherits3.default)(InstagramPicker, _Component);

  function InstagramPicker(props) {
    (0, _classCallCheck3.default)(this, InstagramPicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(InstagramPicker).call(this, props));

    _this.state = {
      pics: _this.props.pics,
      selected: []
    };

    _this.select = _this.select.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InstagramPicker, [{
    key: 'select',
    value: function select(pic) {
      var selected = this.state.selected;

      var idx = selected.findIndex(function (select) {
        if (select.url === pic.url) {
          return true;
        }
      });

      if (idx !== -1) {
        selected.splice(idx, 1);
      } else {
        selected.push(pic);
      }

      this.setState({ selected: selected });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./InstagramPicker.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.picker },
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'h3',
            null,
            'Pick one or multiple pics of your outfit'
          ),
          _react2.default.createElement(
            'button',
            { onClick: this.props.onClose },
            _react2.default.createElement('i', { className: 'ion-android-close' })
          )
        ),
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          {
            universal: true,
            autoHide: true,
            style: { height: 'calc(100vh - 100px)' } },
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            this.props.pics.map(function (pic) {
              return _react2.default.createElement(
                'div',
                { className: 'col--1-of-3' },
                _react2.default.createElement(_InstagramPic2.default, { onSelect: function onSelect() {
                    return _this2.select(pic);
                  }, pic: pic })
              );
            })
          )
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(styles.btn, (0, _defineProperty3.default)({}, styles.isDisplayed, this.state.selected.length > 0)),
            onClick: function onClick() {
              _this2.props.onSelected(_this2.state.selected);
              _this2.props.onClose();
            } },
          'Add selected picture',
          this.state.selected.length > 1 && 's'
        )
      );
    }
  }]);
  return InstagramPicker;
}(_react.Component);

exports.default = InstagramPicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPicker/InstagramPicker.js
 ** module id = 1095
 ** module chunks = 0
 **/